import { render, staticRenderFns } from "./CopyrightComponent.vue?vue&type=template&id=300e041e&scoped=true"
var script = {}
import style0 from "./CopyrightComponent.vue?vue&type=style&index=0&id=300e041e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300e041e",
  null
  
)

export default component.exports